var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      height: 700,
      maxWidth: "700",
      width: 700,
      scrollable: "",
      title: _vm.$t("label_essweb_approvalTemplate_form_dialog_viewNodeTitle"),
      dialog: _vm.show,
    },
    on: { close: _vm.closeDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c("Taber", {
              attrs: {
                curTab: _vm.curTab,
                items: _vm.taber,
                special: "",
                backgroundColor: "white",
              },
              on: {
                change: function (tab) {
                  return (_vm.curTab = tab)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "content-1",
                  fn: function () {
                    return [
                      _c(
                        "v-form",
                        { ref: "form", attrs: { "lazy-validation": "" } },
                        [
                          _c(
                            "v-row",
                            { attrs: { dense: "" } },
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    dense: "",
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("inputTextFiledMultiLang", {
                                    attrs: {
                                      readonly: !_vm.iSEdited,
                                      filled: _vm.iSEdited,
                                      bindData:
                                        _vm.approvalNodeData
                                          .flow_template_node_name,
                                      label: _vm.$t(
                                        "label_essweb_approvalTemplate_form_dialog_nodeNameLabel"
                                      ),
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                    },
                                    on: {
                                      change: function (valueArr) {
                                        _vm.approvalNodeData.flow_template_node_name =
                                          valueArr
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    dense: "",
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("inputTextFiledMultiLang", {
                                    attrs: {
                                      readonly: !_vm.iSEdited,
                                      filled: _vm.iSEdited,
                                      bindData:
                                        _vm.approvalNodeData
                                          .flow_template_node_description,
                                      label: _vm.$t(
                                        "label_essweb_approvalTemplate_form_dialog_descriptionLabel"
                                      ),
                                    },
                                    on: {
                                      change: function (valueArr) {
                                        _vm.approvalNodeData.flow_template_node_description =
                                          valueArr
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    dense: "",
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    { staticClass: "text--secondary" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_approvalTemplate_form_dialog_remarkLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("v-textarea", {
                                    attrs: {
                                      rows: "5",
                                      "no-resize": "",
                                      readonly: !_vm.iSEdited,
                                      filled: _vm.iSEdited,
                                      maxlength: "500",
                                      "single-line": "",
                                      dense: "",
                                      counter: "500",
                                    },
                                    model: {
                                      value: _vm.approvalNodeData.remarks,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.approvalNodeData,
                                          "remarks",
                                          $$v
                                        )
                                      },
                                      expression: "approvalNodeData.remarks",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-2",
                  fn: function () {
                    return [
                      _c(
                        "v-form",
                        { attrs: { "lazy-validation": "" } },
                        [
                          _c(
                            "v-row",
                            { attrs: { dense: "" } },
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    { staticClass: "text--secondary" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "label_essweb_approvalTemplate_form_dialog_actionLabel"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c("v-select", {
                                    attrs: {
                                      dense: "",
                                      "single-line": "",
                                      "append-icon": "",
                                      multiple: "",
                                      readonly: "",
                                      "menu-props": {
                                        offsetY: true,
                                        transition: "slide-y-transition",
                                        rounded: true,
                                        contentClass: "elevation-4",
                                      },
                                      items: _vm.actionList,
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "no-data",
                                        fn: function () {
                                          return [_c("noContent")]
                                        },
                                        proxy: true,
                                      },
                                      {
                                        key: "selection",
                                        fn: function (ref) {
                                          var attrs = ref.attrs
                                          var item = ref.item
                                          var parent = ref.parent
                                          var selected = ref.selected
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(item) +
                                                    (_vm.curAction[
                                                      _vm.curAction.length - 1
                                                    ] == item
                                                      ? ""
                                                      : ",")
                                                ) +
                                                " "
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                    model: {
                                      value: _vm.curAction,
                                      callback: function ($$v) {
                                        _vm.curAction = $$v
                                      },
                                      expression: "curAction",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("normalInputTextFiled", {
                                    attrs: {
                                      readonly: true,
                                      filled: false,
                                      value: Number(
                                        _vm.approvalNodeData
                                          .is_alert_notification
                                      )
                                        ? _vm.$t(
                                            "label_essweb_system_label_trueLabel"
                                          )
                                        : _vm.$t(
                                            "label_essweb_system_label_falseLabel"
                                          ),
                                      label: _vm.$t(
                                        "label_essweb_approvalTemplate_form_dialog_notificationLabel"
                                      ),
                                      dense: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                              Number(_vm.approvalNodeData.is_alert_notification)
                                ? _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        xs: "12",
                                        sm: "12",
                                        md: "12",
                                        lg: "12",
                                        cols: "12",
                                      },
                                    },
                                    [
                                      _c("normalInputTextFiled", {
                                        attrs: {
                                          type: "text",
                                          readonly: !_vm.iSEdited,
                                          filled: _vm.iSEdited,
                                          label: _vm.$t(
                                            "label_essweb_approvalTemplate_form_dialog_approvalNotiOverDateLabel"
                                          ),
                                        },
                                        model: {
                                          value:
                                            _vm.approvalNodeData
                                              .approver_notify_threshold,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.approvalNodeData,
                                              "approver_notify_threshold",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "approvalNodeData.approver_notify_threshold",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    { staticClass: "pl-1 text--secondary" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "label_essweb_approvalTemplate_form_dialog_approverLabel"
                                            )
                                          ) +
                                          " "
                                      ),
                                      Number(_vm.approvers) === 2
                                        ? _c("span", [
                                            _vm._v(
                                              " (" +
                                                _vm._s(
                                                  _vm.$t(
                                                    "label_essweb_approvalTemplate_form_dialog_approverJobLabel"
                                                  )
                                                ) +
                                                ") "
                                            ),
                                          ])
                                        : _vm._e(),
                                      Number(_vm.approvers) === 3
                                        ? _c("span", [
                                            _vm._v(
                                              " (" +
                                                _vm._s(
                                                  _vm.$t(
                                                    "label_essweb_approvalTemplate_form_dialog_staffLabel"
                                                  )
                                                ) +
                                                ") "
                                            ),
                                          ])
                                        : _vm._e(),
                                      Number(_vm.approvers) === 4
                                        ? _c("span", [
                                            _vm._v(
                                              "(" +
                                                _vm._s(
                                                  _vm.$t(
                                                    "label_essweb_approvalTemplate_form_dialog_nodalApproverLabel"
                                                  )
                                                ) +
                                                ") "
                                            ),
                                          ])
                                        : _vm._e(),
                                      Number(_vm.approvers) === 5
                                        ? _c("span", [
                                            _vm._v(
                                              " (" +
                                                _vm._s(
                                                  _vm.$t(
                                                    "label_essweb_approvalTemplate_form_dialog_nodalApproverSupervisorLabel"
                                                  )
                                                ) +
                                                ") "
                                            ),
                                          ])
                                        : _vm._e(),
                                      Number(_vm.approvers) === 7
                                        ? _c("span", [
                                            _vm._v(
                                              "(" +
                                                _vm._s(
                                                  _vm.$t(
                                                    "label_essweb_approvalTemplate_form_dialog_senderStaffShipLabel"
                                                  )
                                                ) +
                                                ") "
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm.approvers != null &&
                                  Number(_vm.approvers) == 0
                                    ? [
                                        _c("normalInputTextFiled", {
                                          attrs: {
                                            readonly: true,
                                            filled: false,
                                            value: _vm.$t(
                                              "label_essweb_approvalTemplate_form_dialog_senderSupervisorLabel"
                                            ),
                                            showLabel: false,
                                            dense: "",
                                          },
                                        }),
                                      ]
                                    : _vm._e(),
                                  Number(_vm.approvers) == 1
                                    ? [
                                        _c("normalInputTextFiled", {
                                          attrs: {
                                            readonly: true,
                                            filled: false,
                                            value: _vm.$t(
                                              "label_essweb_approvalTemplate_form_dialog_approverSupervisorLabel"
                                            ),
                                            showLabel: false,
                                            dense: "",
                                          },
                                        }),
                                      ]
                                    : _vm._e(),
                                  Number(_vm.approvers) == 2
                                    ? [
                                        _c("v-autocomplete", {
                                          attrs: {
                                            items: _vm.allJob,
                                            chips: "",
                                            "deletable-chips": false,
                                            multiple: "",
                                            "append-icon": "",
                                            "hide-details": "",
                                            filter: _vm.jobFliter,
                                            "single-line": "",
                                            readonly: "",
                                            color: "primary lighten-2",
                                            "item-text": "view_fields",
                                            "item-value": "value_field",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "no-data",
                                                fn: function () {
                                                  return [_c("noContent")]
                                                },
                                                proxy: true,
                                              },
                                              {
                                                key: "selection",
                                                fn: function (data) {
                                                  return [
                                                    _c(
                                                      "v-chip",
                                                      _vm._b(
                                                        {
                                                          attrs: {
                                                            "input-value":
                                                              data.selected,
                                                          },
                                                          on: {
                                                            click: data.select,
                                                            "click:close":
                                                              function (
                                                                $event
                                                              ) {
                                                                return _vm.removeJob(
                                                                  data.item
                                                                )
                                                              },
                                                          },
                                                        },
                                                        "v-chip",
                                                        data.attrs,
                                                        false
                                                      ),
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$getCommonLangValue(
                                                                data.item
                                                                  .view_fields
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            4097756618
                                          ),
                                          model: {
                                            value: _vm.approvalNodeData.forJob,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.approvalNodeData,
                                                "forJob",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "approvalNodeData.forJob",
                                          },
                                        }),
                                      ]
                                    : _vm._e(),
                                  Number(_vm.approvers) == 3
                                    ? [
                                        _c("AutoComplete", {
                                          attrs: {
                                            items: _vm.allStaff,
                                            chips: "",
                                            multiple: "",
                                            filter: _vm.$staffFilter,
                                            readonly: "",
                                            avatar: "",
                                            "small-chips": "",
                                            "hide-details": "",
                                            "item-text": "staff_code",
                                            "item-value": "staff_id",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "selection.avatar",
                                                fn: function (ref) {
                                                  var data = ref.data
                                                  return [
                                                    _c("StaffAvatar", {
                                                      attrs: {
                                                        left: "",
                                                        small: "",
                                                        src: data.item
                                                          .staff_avatar,
                                                        staff_name:
                                                          data.item
                                                            .preferred_name,
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "selection",
                                                fn: function (ref) {
                                                  var data = ref.data
                                                  return [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$getCommonLangValue(
                                                            data.item
                                                              .preferred_name
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            2968376871
                                          ),
                                          model: {
                                            value: _vm.approvalNodeData.Staffs,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.approvalNodeData,
                                                "Staffs",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "approvalNodeData.Staffs",
                                          },
                                        }),
                                      ]
                                    : _vm._e(),
                                  Number(_vm.approvers) == 4
                                    ? [
                                        _c("v-autocomplete", {
                                          attrs: {
                                            items: _vm.allNode,
                                            chips: "",
                                            "hide-details": "",
                                            "deletable-chips": false,
                                            "single-line": "",
                                            readonly: "",
                                            "append-icon": "",
                                            "item-text":
                                              "flow_template_node_name",
                                            "item-value": _vm.curUuid
                                              ? "uuid"
                                              : "number",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "no-data",
                                                fn: function () {
                                                  return [_c("noContent")]
                                                },
                                                proxy: true,
                                              },
                                              {
                                                key: "selection",
                                                fn: function (data) {
                                                  return [
                                                    _c(
                                                      "v-chip",
                                                      _vm._b(
                                                        {
                                                          attrs: {
                                                            "input-value":
                                                              data.selected,
                                                          },
                                                          on: {
                                                            click: data.select,
                                                            "click:close":
                                                              function (
                                                                $event
                                                              ) {
                                                                _vm.approvalNodeData.applicantMan =
                                                                  ""
                                                              },
                                                          },
                                                        },
                                                        "v-chip",
                                                        data.attrs,
                                                        false
                                                      ),
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$getCommonLangValue(
                                                                data.item
                                                                  .flow_template_node_name
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "item",
                                                fn: function (data) {
                                                  return [
                                                    _c(
                                                      "v-list",
                                                      {
                                                        attrs: {
                                                          rounded: "",
                                                          width: "100%",
                                                          nav: "",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item",
                                                          {
                                                            attrs: {
                                                              rouned: "",
                                                              width: "100%",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item-content",
                                                              [
                                                                _c(
                                                                  "v-list-item-title",
                                                                  {
                                                                    domProps: {
                                                                      innerHTML:
                                                                        _vm._s(
                                                                          _vm.$getCommonLangValue(
                                                                            data
                                                                              .item
                                                                              .flow_template_node_name
                                                                          )
                                                                        ),
                                                                    },
                                                                  }
                                                                ),
                                                                _c(
                                                                  "v-list-item-subtitle",
                                                                  {
                                                                    domProps: {
                                                                      innerHTML:
                                                                        _vm._s(
                                                                          _vm.$getCommonLangValue(
                                                                            data
                                                                              .item
                                                                              .flow_template_node_description
                                                                          )
                                                                        ),
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            1766601000
                                          ),
                                          model: {
                                            value:
                                              _vm.approvalNodeData.applicantMan,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.approvalNodeData,
                                                "applicantMan",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "approvalNodeData.applicantMan",
                                          },
                                        }),
                                      ]
                                    : _vm._e(),
                                  Number(_vm.approvers) == 5
                                    ? [
                                        _c("v-autocomplete", {
                                          attrs: {
                                            items: _vm.allNode,
                                            chips: "",
                                            "deletable-chips": false,
                                            "hide-details": "",
                                            "single-line": "",
                                            readonly: "",
                                            "append-icon": "",
                                            color: "primary lighten-2",
                                            "item-text":
                                              "flow_template_node_name",
                                            "item-value": _vm.curUuid
                                              ? "uuid"
                                              : "number",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "no-data",
                                                fn: function () {
                                                  return [_c("noContent")]
                                                },
                                                proxy: true,
                                              },
                                              {
                                                key: "selection",
                                                fn: function (data) {
                                                  return [
                                                    _c(
                                                      "v-chip",
                                                      _vm._b(
                                                        {
                                                          attrs: {
                                                            "input-value":
                                                              data.selected,
                                                          },
                                                          on: {
                                                            click: data.select,
                                                            "click:close":
                                                              function (
                                                                $event
                                                              ) {
                                                                _vm.approvalNodeData.applicantHeader =
                                                                  ""
                                                              },
                                                          },
                                                        },
                                                        "v-chip",
                                                        data.attrs,
                                                        false
                                                      ),
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$getCommonLangValue(
                                                                data.item
                                                                  .flow_template_node_name
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "item",
                                                fn: function (data) {
                                                  return [
                                                    _c(
                                                      "v-list",
                                                      {
                                                        attrs: {
                                                          rounded: "",
                                                          width: "100%",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item",
                                                          {
                                                            attrs: {
                                                              rouned: "",
                                                              width: "100%",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item-content",
                                                              [
                                                                _c(
                                                                  "v-list-item-title",
                                                                  {
                                                                    domProps: {
                                                                      innerHTML:
                                                                        _vm._s(
                                                                          _vm.$getCommonLangValue(
                                                                            data
                                                                              .item
                                                                              .flow_template_node_name
                                                                          )
                                                                        ),
                                                                    },
                                                                  }
                                                                ),
                                                                _c(
                                                                  "v-list-item-subtitle",
                                                                  {
                                                                    domProps: {
                                                                      innerHTML:
                                                                        _vm._s(
                                                                          _vm.$getCommonLangValue(
                                                                            data
                                                                              .item
                                                                              .flow_template_node_description
                                                                          )
                                                                        ),
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            3395421946
                                          ),
                                          model: {
                                            value:
                                              _vm.approvalNodeData
                                                .applicantHeader,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.approvalNodeData,
                                                "applicantHeader",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "approvalNodeData.applicantHeader",
                                          },
                                        }),
                                      ]
                                    : _vm._e(),
                                  Number(_vm.approvers) == 6
                                    ? [
                                        _c("normalInputTextFiled", {
                                          attrs: {
                                            readonly: true,
                                            filled: false,
                                            value: _vm.$t(
                                              "label_essweb_approvalTemplate_form_dialog_senderAllSupervisorLabel"
                                            ),
                                            showLabel: false,
                                            dense: "",
                                          },
                                        }),
                                      ]
                                    : _vm._e(),
                                  Number(_vm.approvers) == 7
                                    ? [
                                        _c("v-autocomplete", {
                                          attrs: {
                                            items: _vm.allShip,
                                            chips: "",
                                            "deletable-chips": false,
                                            multiple: "",
                                            "append-icon": "",
                                            "hide-details": "",
                                            filter: _vm.shipFliter,
                                            "single-line": "",
                                            readonly: "",
                                            color: "primary lighten-2",
                                            "item-text": "view_fields",
                                            "item-value": "value_field",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "no-data",
                                                fn: function () {
                                                  return [_c("noContent")]
                                                },
                                                proxy: true,
                                              },
                                              {
                                                key: "selection",
                                                fn: function (data) {
                                                  return [
                                                    _c(
                                                      "v-chip",
                                                      _vm._b(
                                                        {
                                                          attrs: {
                                                            "input-value":
                                                              data.selected,
                                                          },
                                                          on: {
                                                            click: data.select,
                                                            "click:close":
                                                              function (
                                                                $event
                                                              ) {
                                                                return _vm.removeShip(
                                                                  data.item
                                                                )
                                                              },
                                                          },
                                                        },
                                                        "v-chip",
                                                        data.attrs,
                                                        false
                                                      ),
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$getCommonLangValue(
                                                                data.item
                                                                  .view_fields
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "item",
                                                fn: function (data) {
                                                  return [
                                                    _c(
                                                      "v-list",
                                                      {
                                                        attrs: {
                                                          rounded: "",
                                                          width: "100%",
                                                          nav: "",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item",
                                                          {
                                                            attrs: {
                                                              rouned: "",
                                                              width: "100%",
                                                              nav: "",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item-content",
                                                              [
                                                                _c(
                                                                  "v-list-item-title",
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$getCommonLangValue(
                                                                          data
                                                                            .item
                                                                            .view_fields
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            1643909728
                                          ),
                                          model: {
                                            value:
                                              _vm.approvalNodeData.correlation,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.approvalNodeData,
                                                "correlation",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "approvalNodeData.correlation",
                                          },
                                        }),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    { staticClass: "pl-1 text--secondary" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "label_essweb_approvalTemplate_form_dialog_emailCCLabel"
                                            )
                                          ) +
                                          " "
                                      ),
                                      Number(_vm.copySender) === 2
                                        ? _c("span", [
                                            _vm._v(
                                              " (" +
                                                _vm._s(
                                                  _vm.$t(
                                                    "label_essweb_approvalTemplate_form_dialog_approverJobLabel"
                                                  )
                                                ) +
                                                ") "
                                            ),
                                          ])
                                        : _vm._e(),
                                      Number(_vm.copySender) === 3
                                        ? _c("span", [
                                            _vm._v(
                                              " (" +
                                                _vm._s(
                                                  _vm.$t(
                                                    "label_essweb_approvalTemplate_form_dialog_staffLabel"
                                                  )
                                                ) +
                                                ") "
                                            ),
                                          ])
                                        : _vm._e(),
                                      Number(_vm.copySender) === 4
                                        ? _c("span", [
                                            _vm._v(
                                              "(" +
                                                _vm._s(
                                                  _vm.$t(
                                                    "label_essweb_approvalTemplate_form_dialog_nodalApproverLabel"
                                                  )
                                                ) +
                                                ") "
                                            ),
                                          ])
                                        : _vm._e(),
                                      Number(_vm.copySender) === 5
                                        ? _c("span", [
                                            _vm._v(
                                              " (" +
                                                _vm._s(
                                                  _vm.$t(
                                                    "label_essweb_approvalTemplate_form_dialog_nodalApproverSupervisorLabel"
                                                  )
                                                ) +
                                                ") "
                                            ),
                                          ])
                                        : _vm._e(),
                                      Number(_vm.copySender) === 7
                                        ? _c("span", [
                                            _vm._v(
                                              "(" +
                                                _vm._s(
                                                  _vm.$t(
                                                    "label_essweb_approvalTemplate_form_dialog_senderStaffShipLabel"
                                                  )
                                                ) +
                                                ") "
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm.copySender == -1
                                    ? [
                                        _c("normalInputTextFiled", {
                                          attrs: {
                                            readonly: true,
                                            filled: false,
                                            value: _vm.$t(
                                              "label_essweb_approvalTemplate_form_dialog_notCCLabel"
                                            ),
                                            showLabel: false,
                                            dense: "",
                                          },
                                        }),
                                      ]
                                    : _vm._e(),
                                  _vm.copySender != null &&
                                  Number(_vm.copySender) == 0
                                    ? [
                                        _c("normalInputTextFiled", {
                                          attrs: {
                                            readonly: true,
                                            filled: false,
                                            value: _vm.$t(
                                              "label_essweb_approvalTemplate_form_dialog_senderSupervisorLabel"
                                            ),
                                            showLabel: false,
                                            dense: "",
                                          },
                                        }),
                                      ]
                                    : _vm._e(),
                                  Number(_vm.copySender) == 1
                                    ? [
                                        _c("normalInputTextFiled", {
                                          attrs: {
                                            readonly: true,
                                            filled: false,
                                            value: _vm.$t(
                                              "label_essweb_approvalTemplate_form_dialog_approverSupervisorLabel"
                                            ),
                                            showLabel: false,
                                            dense: "",
                                          },
                                        }),
                                      ]
                                    : _vm._e(),
                                  Number(_vm.copySender) == 2
                                    ? [
                                        _c("v-autocomplete", {
                                          attrs: {
                                            items: _vm.allJob,
                                            chips: "",
                                            "deletable-chips": false,
                                            multiple: "",
                                            "append-icon": "",
                                            "hide-details": "",
                                            filter: _vm.jobFliter,
                                            "single-line": "",
                                            readonly: "",
                                            color: "primary lighten-2",
                                            "item-text": "view_fields",
                                            "item-value": "value_field",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "no-data",
                                                fn: function () {
                                                  return [_c("noContent")]
                                                },
                                                proxy: true,
                                              },
                                              {
                                                key: "selection",
                                                fn: function (data) {
                                                  return [
                                                    _c(
                                                      "v-chip",
                                                      _vm._b(
                                                        {
                                                          attrs: {
                                                            "input-value":
                                                              data.selected,
                                                          },
                                                          on: {
                                                            click: data.select,
                                                            "click:close":
                                                              function (
                                                                $event
                                                              ) {
                                                                return _vm.removeJob(
                                                                  data.item,
                                                                  true
                                                                )
                                                              },
                                                          },
                                                        },
                                                        "v-chip",
                                                        data.attrs,
                                                        false
                                                      ),
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$getCommonLangValue(
                                                                data.item
                                                                  .view_fields
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "item",
                                                fn: function (data) {
                                                  return [
                                                    _c(
                                                      "v-list",
                                                      {
                                                        staticClass: "pa-0",
                                                        attrs: {
                                                          width: "100%",
                                                          nav: "",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item",
                                                          {
                                                            attrs: {
                                                              rouned: "",
                                                              width: "100%",
                                                              nav: "",
                                                              "two-line": "",
                                                              dense: "",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item-content",
                                                              [
                                                                _c(
                                                                  "v-list-item-title",
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$getCommonLangValue(
                                                                          data
                                                                            .item
                                                                            .view_fields
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "v-list-item-subtitle",
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$getCommonLangValue(
                                                                          data
                                                                            .item
                                                                            .f1
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            303229957
                                          ),
                                          model: {
                                            value:
                                              _vm.approvalNodeData.forJob_cc,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.approvalNodeData,
                                                "forJob_cc",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "approvalNodeData.forJob_cc",
                                          },
                                        }),
                                      ]
                                    : _vm._e(),
                                  Number(_vm.copySender) == 3
                                    ? [
                                        _c("v-autocomplete", {
                                          attrs: {
                                            items: _vm.allStaff,
                                            chips: "",
                                            multiple: "",
                                            filter: _vm.$staffFilter,
                                            readonly: "",
                                            "append-icon": "",
                                            "deletable-chips": false,
                                            "hide-details": "",
                                            "single-line": "",
                                            "item-text": "staff_code",
                                            "item-value": "staff_id",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "no-data",
                                                fn: function () {
                                                  return [_c("noContent")]
                                                },
                                                proxy: true,
                                              },
                                              {
                                                key: "selection",
                                                fn: function (data) {
                                                  return [
                                                    _c(
                                                      "v-chip",
                                                      _vm._b(
                                                        {
                                                          attrs: {
                                                            pill: "",
                                                            "input-value":
                                                              data.selected,
                                                          },
                                                          on: {
                                                            click: data.select,
                                                            "click:close":
                                                              function (
                                                                $event
                                                              ) {
                                                                return _vm.removeStaff(
                                                                  data.item,
                                                                  true
                                                                )
                                                              },
                                                          },
                                                        },
                                                        "v-chip",
                                                        data.attrs,
                                                        false
                                                      ),
                                                      [
                                                        _c("StaffAvatar", {
                                                          attrs: {
                                                            left: "",
                                                            src: data.item
                                                              .staff_avatar,
                                                            staff_name:
                                                              data.item
                                                                .preferred_name,
                                                          },
                                                        }),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$getCommonLangValue(
                                                                data.item
                                                                  .preferred_name
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "item",
                                                fn: function (data) {
                                                  return [
                                                    _c(
                                                      "v-list",
                                                      {
                                                        attrs: {
                                                          rounded: "",
                                                          width: "100%",
                                                          nav: "",
                                                          "two-line": "",
                                                          dense: "",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item",
                                                          {
                                                            attrs: {
                                                              rouned: "",
                                                              width: "100%",
                                                              nav: "",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item-avatar",
                                                              {
                                                                staticClass:
                                                                  "ma-0 mr-1 white--text",
                                                                attrs: {
                                                                  size: "36",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "StaffAvatar",
                                                                  {
                                                                    attrs: {
                                                                      size: "36",
                                                                      src: data
                                                                        .item
                                                                        .staff_avatar,
                                                                      staff_name:
                                                                        data
                                                                          .item
                                                                          .preferred_name,
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "v-list-item-content",
                                                              [
                                                                _c(
                                                                  "v-list-item-title",
                                                                  {
                                                                    staticClass:
                                                                      "text-body-2",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$getCommonLangValue(
                                                                          data
                                                                            .item
                                                                            .preferred_name
                                                                        )
                                                                      ) + " "
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "text--secondary text-caption-xs",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            data
                                                                              .item
                                                                              .staff_code
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "v-list-item-subtitle",
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$getCommonLangValue(
                                                                          data
                                                                            .item
                                                                            .job_post_name
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            3798767840
                                          ),
                                          model: {
                                            value:
                                              _vm.approvalNodeData.Staffs_cc,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.approvalNodeData,
                                                "Staffs_cc",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "approvalNodeData.Staffs_cc",
                                          },
                                        }),
                                      ]
                                    : _vm._e(),
                                  Number(_vm.copySender) == 4
                                    ? [
                                        _c("v-autocomplete", {
                                          attrs: {
                                            items: _vm.allNode,
                                            chips: "",
                                            "hide-details": "",
                                            "deletable-chips": false,
                                            "single-line": "",
                                            readonly: "",
                                            "append-icon": "",
                                            "item-text":
                                              "flow_template_node_name",
                                            "item-value": _vm.curUuid
                                              ? "uuid"
                                              : "number",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "no-data",
                                                fn: function () {
                                                  return [_c("noContent")]
                                                },
                                                proxy: true,
                                              },
                                              {
                                                key: "selection",
                                                fn: function (data) {
                                                  return [
                                                    _c(
                                                      "v-chip",
                                                      _vm._b(
                                                        {
                                                          attrs: {
                                                            "input-value":
                                                              data.selected,
                                                          },
                                                          on: {
                                                            click: data.select,
                                                            "click:close":
                                                              function (
                                                                $event
                                                              ) {
                                                                _vm.approvalNodeData.applicantMan_cc =
                                                                  ""
                                                              },
                                                          },
                                                        },
                                                        "v-chip",
                                                        data.attrs,
                                                        false
                                                      ),
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$getCommonLangValue(
                                                                data.item
                                                                  .flow_template_node_name
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "item",
                                                fn: function (data) {
                                                  return [
                                                    _c(
                                                      "v-list",
                                                      {
                                                        attrs: {
                                                          rounded: "",
                                                          width: "100%",
                                                          nav: "",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item",
                                                          {
                                                            attrs: {
                                                              rouned: "",
                                                              width: "100%",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item-content",
                                                              [
                                                                _c(
                                                                  "v-list-item-title",
                                                                  {
                                                                    domProps: {
                                                                      innerHTML:
                                                                        _vm._s(
                                                                          _vm.$getCommonLangValue(
                                                                            data
                                                                              .item
                                                                              .flow_template_node_name
                                                                          )
                                                                        ),
                                                                    },
                                                                  }
                                                                ),
                                                                _c(
                                                                  "v-list-item-subtitle",
                                                                  {
                                                                    domProps: {
                                                                      innerHTML:
                                                                        _vm._s(
                                                                          _vm.$getCommonLangValue(
                                                                            data
                                                                              .item
                                                                              .flow_template_node_description
                                                                          )
                                                                        ),
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            798691063
                                          ),
                                          model: {
                                            value:
                                              _vm.approvalNodeData
                                                .applicantMan_cc,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.approvalNodeData,
                                                "applicantMan_cc",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "approvalNodeData.applicantMan_cc",
                                          },
                                        }),
                                      ]
                                    : _vm._e(),
                                  Number(_vm.copySender) == 5
                                    ? [
                                        _c("v-autocomplete", {
                                          attrs: {
                                            items: _vm.allNode,
                                            chips: "",
                                            "deletable-chips": false,
                                            "hide-details": "",
                                            "single-line": "",
                                            readonly: "",
                                            "append-icon": "",
                                            color: "primary lighten-2",
                                            "item-text":
                                              "flow_template_node_name",
                                            "item-value": _vm.curUuid
                                              ? "uuid"
                                              : "number",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "no-data",
                                                fn: function () {
                                                  return [_c("noContent")]
                                                },
                                                proxy: true,
                                              },
                                              {
                                                key: "selection",
                                                fn: function (data) {
                                                  return [
                                                    _c(
                                                      "v-chip",
                                                      _vm._b(
                                                        {
                                                          attrs: {
                                                            "input-value":
                                                              data.selected,
                                                          },
                                                          on: {
                                                            click: data.select,
                                                            "click:close":
                                                              function (
                                                                $event
                                                              ) {
                                                                _vm.approvalNodeData.applicantHeader_cc =
                                                                  ""
                                                              },
                                                          },
                                                        },
                                                        "v-chip",
                                                        data.attrs,
                                                        false
                                                      ),
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$getCommonLangValue(
                                                                data.item
                                                                  .flow_template_node_name
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "item",
                                                fn: function (data) {
                                                  return [
                                                    _c(
                                                      "v-list",
                                                      {
                                                        attrs: {
                                                          rounded: "",
                                                          width: "100%",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item",
                                                          {
                                                            attrs: {
                                                              rouned: "",
                                                              width: "100%",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item-content",
                                                              [
                                                                _c(
                                                                  "v-list-item-title",
                                                                  {
                                                                    domProps: {
                                                                      innerHTML:
                                                                        _vm._s(
                                                                          _vm.$getCommonLangValue(
                                                                            data
                                                                              .item
                                                                              .flow_template_node_name
                                                                          )
                                                                        ),
                                                                    },
                                                                  }
                                                                ),
                                                                _c(
                                                                  "v-list-item-subtitle",
                                                                  {
                                                                    domProps: {
                                                                      innerHTML:
                                                                        _vm._s(
                                                                          _vm.$getCommonLangValue(
                                                                            data
                                                                              .item
                                                                              .flow_template_node_description
                                                                          )
                                                                        ),
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            2458484261
                                          ),
                                          model: {
                                            value:
                                              _vm.approvalNodeData
                                                .applicantHeader_cc,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.approvalNodeData,
                                                "applicantHeader_cc",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "approvalNodeData.applicantHeader_cc",
                                          },
                                        }),
                                      ]
                                    : _vm._e(),
                                  Number(_vm.copySender) == 6
                                    ? [
                                        _c("normalInputTextFiled", {
                                          attrs: {
                                            readonly: true,
                                            filled: false,
                                            value: _vm.$t(
                                              "label_essweb_approvalTemplate_form_dialog_senderAllSupervisorLabel"
                                            ),
                                            showLabel: false,
                                            dense: "",
                                          },
                                        }),
                                      ]
                                    : _vm._e(),
                                  Number(_vm.copySender) == 7
                                    ? [
                                        _c("v-autocomplete", {
                                          attrs: {
                                            items: _vm.allShip,
                                            chips: "",
                                            "deletable-chips": false,
                                            multiple: "",
                                            "append-icon": "",
                                            "hide-details": "",
                                            filter: _vm.shipFliter,
                                            "single-line": "",
                                            readonly: "",
                                            color: "primary lighten-2",
                                            "item-text": "view_fields",
                                            "item-value": "value_field",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "no-data",
                                                fn: function () {
                                                  return [_c("noContent")]
                                                },
                                                proxy: true,
                                              },
                                              {
                                                key: "selection",
                                                fn: function (data) {
                                                  return [
                                                    _c(
                                                      "v-chip",
                                                      _vm._b(
                                                        {
                                                          attrs: {
                                                            "input-value":
                                                              data.selected,
                                                          },
                                                          on: {
                                                            click: data.select,
                                                            "click:close":
                                                              function (
                                                                $event
                                                              ) {
                                                                return _vm.removeShip(
                                                                  data.item,
                                                                  true
                                                                )
                                                              },
                                                          },
                                                        },
                                                        "v-chip",
                                                        data.attrs,
                                                        false
                                                      ),
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$getCommonLangValue(
                                                                data.item
                                                                  .view_fields
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "item",
                                                fn: function (data) {
                                                  return [
                                                    _c(
                                                      "v-list",
                                                      {
                                                        attrs: {
                                                          rounded: "",
                                                          width: "100%",
                                                          nav: "",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item",
                                                          {
                                                            attrs: {
                                                              rouned: "",
                                                              width: "100%",
                                                              nav: "",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item-content",
                                                              [
                                                                _c(
                                                                  "v-list-item-title",
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$getCommonLangValue(
                                                                          data
                                                                            .item
                                                                            .view_fields
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            3393383770
                                          ),
                                          model: {
                                            value:
                                              _vm.approvalNodeData
                                                .correlation_cc,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.approvalNodeData,
                                                "correlation_cc",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "approvalNodeData.correlation_cc",
                                          },
                                        }),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-3",
                  fn: function () {
                    return [
                      _c(
                        "v-form",
                        { ref: "form2", attrs: { "lazy-validation": "" } },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    dense: "",
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    { staticClass: "text--secondary" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_approvalTemplate_form_dialog_filedLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("v-autocomplete", {
                                    attrs: {
                                      items: _vm.allField,
                                      "item-text": "view_fields",
                                      "item-value": "value_field",
                                      "small-chips": "",
                                      "single-line": "",
                                      readonly: !_vm.iSEdited,
                                      "append-icon": _vm.iSEdited
                                        ? "arrow_drop_down"
                                        : "",
                                      filled: _vm.iSEdited,
                                      "menu-props": {
                                        offsetY: true,
                                        transition: "slide-y-transition",
                                        rounded: true,
                                        contentClass: "elevation-4",
                                      },
                                      "deletable-chips": "",
                                      multiple: "",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "no-data",
                                        fn: function () {
                                          return [_c("noContent")]
                                        },
                                        proxy: true,
                                      },
                                      {
                                        key: "item",
                                        fn: function (data) {
                                          return [
                                            _c(
                                              "v-list-item-content",
                                              [
                                                _c("v-list-item-title", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      data.item.view_fields
                                                    ),
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                    model: {
                                      value: _vm.approvalNodeData.field_uuid,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.approvalNodeData,
                                          "field_uuid",
                                          $$v
                                        )
                                      },
                                      expression: "approvalNodeData.field_uuid",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _vm.iSEdited
              ? _c("CardActions", {
                  attrs: { saveBtn: "" },
                  on: { cancel: _vm.closeDialog },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }